import React from 'react';
import config from '@/configs/config';
import { InverntoryStatusLabel } from '../MenuProvider';

export default ({ data: { inventory } }) => (
  <>
    <div style={{ alignItems: 'flex-start' }}>
      <InverntoryStatusLabel status={inventory} />
    </div>
    <div>
      本商品目前架上庫存充足，可直接前往
      {config.BrandNameTW}
      機台選購。
    </div>
    <div style={{ marginTop: 8 }}>
      PS:每個機台菜單及庫存各不相同，請確認您的
      {config.BrandNameTW}
      機台位置，也可選擇其他日期之菜單，提前預訂商品。
    </div>
  </>
);
